import { render, staticRenderFns } from "./producer_checkout_card.vue?vue&type=template&id=c0c2781a&scoped=true"
import script from "./producer_checkout_card.vue?vue&type=script&lang=js"
export * from "./producer_checkout_card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c2781a",
  null
  
)

export default component.exports